export default {"src":"/_next/static/media/x-close-modal-icon.11502fbd.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};